import { groupBy } from 'lodash';
import WorkflowList from './WorkflowList';
import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import TabPanel from 'components/TabPanel/TabPanel';
import { existTabItems } from 'pages/globals/global';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ComptrollerPageHeader from 'components/header/ComptrollerPageHeader';
import { useGetAllWorkFlowDesignMutation } from 'store/features/process/processApi';
import SectionCard from '../../../components/section/SectionCard';

function Index() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [tabsItem, setTabsItem] = useState([]);
	const [selectedTab, setSelectedTab] = useState(0);
	const [reloadTable, setReloadTable] = useState(false);
	const [workflowTable, setWorkflowTable] = useState([]);
	const [activeCreateButton, setActiveCreateButton] = useState(true);

	const [getAllWorkFlowDesign, { data: workflowDesignList, isLoading }] = useGetAllWorkFlowDesignMutation();

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);

		const tabName = tabsItem?.[newValue]?.label?.toLowerCase()?.replaceAll('-', '');

		navigate(`/comptroller/work-flow?tab=${tabName}`);
	};

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading]);

	useEffect(() => {
		getAllWorkFlowDesign();
	}, [reloadTable]);

	useEffect(() => {
		if (workflowDesignList?.result) {
			const arr1 = groupBy(workflowDesignList?.result, 'activationStatus');

			arr1['All'] = workflowDesignList?.result ?? [];

			const arr2 = Object.keys(arr1);

			const newTabs = existTabItems?.filter((item) => arr2.includes(item.data));

			setTabsItem(newTabs);
			setWorkflowTable(arr1);
		}
	}, [workflowDesignList]);

	useEffect(() => {
		const activeTab = searchParams.get('tab');

		if (tabsItem?.length > 0 && activeTab) {
			const index = tabsItem?.findIndex((item) => item?.label?.toLowerCase()?.replaceAll('-', '') === activeTab);

			if (index > -1) setSelectedTab(index);
			else setSelectedTab(0);
		}
	}, [tabsItem]);

	return (
		<>
			<Grid container rowSpacing={4.5} columnSpacing={2.75}>
				<Grid item xs={12}>
					<ComptrollerPageHeader
						title="Work Flow"
						tabsItem={tabsItem}
						selectedTab={selectedTab}
						selectTabHandler={selectTabHandler}
						activeCreateButton={activeCreateButton}
						navigate={() => {
							navigate('/comptroller/work-flow/create', {});
						}}
					/>

					<Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
						{tabsItem?.map((item, index) => (
							<TabPanel key={index} value={selectedTab} index={index} sx={{ height: 'calc(100% - 38px)' }}>
								<SectionCard>
									<WorkflowList
										navigate={navigate}
										isLoading={isLoading}
										setReloadTable={setReloadTable}
										workflowList={workflowTable[item?.data]}
										selectedTabName={tabsItem?.[selectedTab]?.data}
									/>
								</SectionCard>
							</TabPanel>
						))}
					</Box>
				</Grid>
			</Grid>
		</>
	);
}

export default Index;
